// extracted by mini-css-extract-plugin
module.exports = {"summary":"Accordion_summary__FVyc3","summaryOpen":"Accordion_summaryOpen__KAfEb"};